import React from 'react';
import ReactDOM from 'react-dom';
import './index.Scss';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Services/redux/store';
import 'antd/dist/antd.css';
import 'bootstrap/dist/css/bootstrap.min.css';


ReactDOM.render(
  // <React.StrictMode>
  <Provider {...{ store }}>
    <App />
  </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

